import axios from '@/server/request'

const state = {
    // 事件列表信息
    eventListData: {},
    isEventListLoading: true,

    // 事件信息
    eventInfoData: {},
    isEventInfoLoading: true,

    // 事件地图分布数据
    eventMapData: {},
    isEventMapLoading: true,

    // 每个城市发文数据
    cityOfEventData: [],
    isCityOfEventLoading: true,

    // 事件媒体信息
    eventMediaInfoOptions: [],
    isEventMediaInfoLoading: true,

    // 文章 - 观点关联数据
    viewportArticleData: {},
    isViewportArticleLoading: true
}

const mutations = {
    updateEventList(state, payload) {
        state.eventListData = null
        state.eventListData = payload
    },

    updateEventListLoading(state, payload) {
        state.isEventListLoading = payload
    },

    updateEventInfo(state, payload) {
        state.eventInfoData = null
        state.eventInfoData = payload
    },

    updateEvenInfoLoading(state, payload) {
        state.isEventInfoLoading = payload
    },

    updateEventMap(state, payload) {
        state.eventMapData = null
        state.eventMapData = payload
    },

    updateEventMapLoading(state, payload) {
        state.isEventMapLoading = payload
    },

    updateCityOfEvent(state, payload) {
        state.cityOfEventData.splice(0)
        state.cityOfEventData = payload
    },

    updateCityOfEventLoading(state, payload) {
        state.isCityOfEventLoading = payload
    },

    updateEventMediaInfo(state, payload) {
        state.eventMediaInfoOptions = null
        state.eventMediaInfoOptions = payload
    },

    updateEventMediaInfoLoading(state, payload) {
        state.isEventMediaInfoLoading = payload
    },

    updateViewportArticle(state, payload) {
        state.viewportArticleData = null
        state.viewportArticleData = payload
    },

    updateViewportArticleLoading(state, payload) {
        state.isViewportArticleLoading = payload
    }
}

const actions = {
    /**
     * 事件列表
     */
    async fetchEventList({ commit }, params) {
        commit('updateEventListLoading', true)
        try {
            const res = await axios.post({
                url: '/Event/eventList',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateEventList', res.data.Data)
                commit('updateEventListLoading', false)
            }
            return Promise.resolve(res)
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateEventListLoading', false)
        }
    },

    /**
     * 事件列表
     */
    async fetchEventInfo({ commit }, params) {
        commit('updateEvenInfoLoading', true)
        try {
            const res = await axios.post({
                url: '/Event/eventinfo',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateEventInfo', res.data.Data)
                commit('updateEvenInfoLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateEvenInfoLoading', false)
        }
    },

    /**
     * 事件文字云图
     */
    async fetchEventMap({ commit }, params) {
        commit('updateEventMapLoading', true)
        try {
            const res = await axios.post({
                url: '/Event/eventMapKey',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateEventMap', res.data.Data)
                commit('updateEventMapLoading', false)
                return Promise.resolve()
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateEventMapLoading', false)
        }
    },

    /**
     * 城市列表 Hover 时拉取的数据
     */
    async fetchCityOfEvent({ commit }, params) {
        commit('updateCityOfEventLoading', true)
        try {
            const res = await axios.post({
                url: '/Event/mapCityHover',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateCityOfEvent', res.data.Data)
                commit('updateCityOfEventLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateCityOfEventLoading', false)
        }
    },

    /**
     * 媒体信息
     */
    async fetchEventMediaInfo({ commit }, params) {
        commit('updateEventMediaInfoLoading', true)
        try {
            const res = await axios.get({
                url: '/Event/mediaNews',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateEventMediaInfo', res.data.Data)
                commit('updateEventMediaInfoLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateEventMediaInfoLoading', false)
        }
    },

    /**
     * 媒体信息
     */
    async fetchViewportArticle({ commit }, params) {
        commit('updateViewportArticleLoading', true)
        try {
            const res = await axios.get({
                url: '/Event/getViewpointArticle',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateViewportArticle', res.data.Data)
                commit('updateViewportArticleLoading', false)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateViewportArticleLoading', false)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
